import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginPrincipalContainerModel} from '../../../../../models/aggregates/app-login';
import {ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel} from '../shared';
import {
  AppLoginCriteriaModelQuery,
  AppLoginQueryCriteriaClass,
  AppLoginPrincipalQueryCriteriaClass,
  AppLoginPrincipalCriteriaModelQuery,
} from '../../criteria';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AppLoginPrincipalService extends BaseApiTemplateService<AppLoginPrincipalContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.httpClient = http;
  }
  
  private setUrl(endpoint: string){
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'app-login-principal' + endpoint;
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'app-login-principal' + endpoint;
  }

  post(dtoObject: AppLoginPrincipalContainerModel, visa: ApiVisa): Observable<ApiResponseModel<AppLoginPrincipalContainerModel>> {
    this.setUrl('');
    return super.post(dtoObject, visa);
  }

  delete(guid: string, visa: ApiVisa): Observable<ApiResponseModel<AppLoginPrincipalContainerModel>> {
    this.setUrl('');
    return super.delete(guid, visa);
  }

  put(dtoObject: AppLoginPrincipalContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<AppLoginPrincipalContainerModel>> {
    this.setUrl('');
    return super.put(dtoObject, visa);
  }

  get(visa: ApiVisa){
    this.setUrl('');
    return super.get(visa);
  }

  getByGuid(guid: string, visa: ApiVisa): Observable<BasicApiResponseModel<AppLoginPrincipalContainerModel>> {
    this.setUrl('');
    return super.getByGuid(guid, visa);
  }

  getByCriteria(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<AppLoginPrincipalContainerModel>> {
    this.setUrl('');
    return super.getByCriteria(pagination, visa);
  }

  getByLoginCriteria(pagination: Pagination, visa: ApiVisa, criteria?: any): Observable<PagingResponseModel<AppLoginPrincipalContainerModel>> {
    this.setUrl('/login-ep');
    return super.getByCriteria(pagination, visa);
  }

  getAppLoginPrincipalByCriteria(pagination: Pagination, apiVisa: ApiVisa, criteria?: AppLoginPrincipalQueryCriteriaClass):
    Observable<PagingResponseModel<AppLoginPrincipalContainerModel>> {
      this.setUrl('');
      return super.getByCriteria(pagination, apiVisa);
    // const buildEntityCriteriaCriteria = new AppLoginPrincipalCriteriaModelQuery(criteria);
    // return this.httpClient.get<PagingResponseModel<AppLoginPrincipalContainerModel>>(visa.api_domain_url + this.endpoint_path + '/query?' +
    //   buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }

  sysadminPost(dtoObject: AppLoginPrincipalContainerModel, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.post(dtoObject, apiVisa);
  }

  sysadminDelete(guid, apiVisa){
    this.setUrl('/sysadmin-ep');
    return super.delete(guid, apiVisa);
  }

  sysadminPut(dtoObject: AppLoginPrincipalContainerModel, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.put(dtoObject, apiVisa);
  }

  sysadminGet(apiVisa){
    this.setUrl('/sysadmin-ep');
    return super.get(apiVisa);
  }

  sysadminGetByGuid(guid: string, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.getByGuid(guid, apiVisa);  
  }

  sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.getByCriteria(pagination, apiVisa);
  }

  // /core2/dm/app-login-principal/{tenantCode}/tenant-admin-ep/query

  tenantAdminGetByCriteria(tenantCode: string, pagination: Pagination, apiVisa: ApiVisa){
    this.setUrl(`/${tenantCode}/tenant-admin-ep`);
    return super.getByCriteria(pagination, apiVisa);
  }

}
